import React, { useEffect, useState, useRef } from "react";
import {ThemeProvider, createTheme } from "@mui/material";
import { Formik, useFormik } from "formik";

import { toast } from "react-toastify";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import GetAppIcon from "@mui/icons-material/GetApp";
import ExportContactMultiSelect from "./ExportContactMultiSelect";
import BulkGroupMultiSelect from "./BulkGroupMultiSelect";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Swal from "sweetalert2";
import { common_axios } from "../../../App";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";

const customId1 = "custom-id-yess";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ExportContact2 = ({ parentCallback, resetValue }) => {
  const [data, setData] = useState([]);
  // console.log("data--", data);
  const [age, setAge] = useState("");
  // console.log("322", age);
  const [open, setOpen] = useState();
  const [exportSelect, setExportSelect] = useState("");
  const [hideSkeleton, setHideSkeleton] = useState();
  const [downloaddata, setDownloaddata] = useState("");
  const [csvselect, setCsvSelect] = useState("");
  const [excelselect, seExcelSelect] = useState("");
  const [DownloadUrl, setDownloadUrl] = useState("");
  const [DownloadDisable, setDownloadDisable] = useState(true);
  const [MenuItemPhoneBook, setMenuItemPhoneBook] = useState(undefined);
  const [DisableMultiSelector, setDisableMultiSelector] = useState(false);

  // console.log("7667", MenuItemPhoneBook);

  const [variantName, setVariantName] = React.useState([]);
  // console.log("variant name-", DownloadUrl);
  const [gId, setGid] = useState([]);
  // console.log("gid--", gId);

  const [variants, setVariants] = React.useState([]);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

   
    // console.log("value--", value);
    // let duplicateRemoved = [];

    // value.forEach((item) => {
    //   console.log("value--", item);
    //   if (duplicateRemoved.findIndex((o) => o.gid == item.gid) >= 0) {
    //     duplicateRemoved = duplicateRemoved.filter((x) => {
    //       return x.gId != item.gid;
    //     });
    //   } else {
    //     console.log({ item });
    //     duplicateRemoved.push(item);
    //   }
    // });

    // setVariantName(duplicateRemoved);
  };

  const uploadreset = () => {
 
    setMenuItemPhoneBook(undefined);
    setGid([]);
  
  };
 // ...................................Theme Provider....................................//
 const theme = createTheme({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        asterisk: { color: "red" },
      },
    },
  },
});
  // ......................Download Modal Open//////////////////////////////////////////////

  const [downloadModelOpen, setDownloadModel] = useState(undefined);
  // console.log("first", downloadModelOpen);
  const modelButtonDownload = useRef(null);
  const DownloadAction = async (cell) => {
    setDownloadModel(cell.row.original);
  };

  //  ...............................Download Button API..............................................//
  async function DownloadButtonApi() {
    try {
      // setHideSkeleton(true)
      if (MenuItemPhoneBook == 0) {
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/export/phone-book/excel`,
          {
            downloadReportRequest: {
              phoneBookId: gId.id,
              reportType: "Phonebook",
              username: localStorage.getItem("Username"),
              phoneBookName: gId?.phonebookName,
            },
          }
        );
        if (result.data.statusdescription.statusCode == 200) {
          // DownloadTabApi()
          setOpen(false);
          const butt = document.getElementById("Download-tab");
          butt.click();
        } else {
          // setData([])

          setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else {
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/export/bulk-group/excel`,
          {
            downloadReportRequest: {
              bulkgroupid: gId?.id,
              reportType: "Bulk group",
              username: localStorage.getItem("Username"),
              bulkgroupname: gId?.bulkGroupName,
            },
          }
        );
        if (result.data.statusdescription.statusCode == 200) {
          // DownloadTabApi()

          setOpen(false);
          const butt = document.getElementById("Download-tab");
          butt.click();
        } else {
          // setData([])

          setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  // .........................................................................//
  // ..................................................................................//

  // const downloadFile = () => {
  //   if (MenuItemPhoneBook == 0) {
  //     if (age == "CSV") {
  //       window.location.href = `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/phone-book/export/csv?phoneBookId=${gId}`; //to download the file from url in download button
  //       setDownloadDisable(true);
  //       setAge(null);
  //     } else {
  //       window.location.href = `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/export/phone-book/excel?phoneBookId=${gId}`; //to download the file from url in download button
  //       setDownloadDisable(true);
  //       setAge(null);
  //     }
  //   } else {
  //     if (age == "CSV") {
  //       window.location.href = `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/bulk-group/export/csv?bulkGroupId=${gId}`; //to download the file from url in download button
  //       setDownloadDisable(true);
  //       setAge(null);
  //     } else {
  //       window.location.href = `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/export/bulk-group/excel?bulkGroupId=${gId}`; //to download the file from url in download button
  //       setDownloadDisable(true);
  //       setAge(null);
  //     }
  //   }
  // };
  const callBackFunction1 = (childData) => {
    setGid(childData);
    // console.log("first", childData);
  };
  const callBackFunction2 = (childData) => {
    setGid(childData);
    // console.log("first", childData);
  };
  // console.log({ age });
  const handleChangee = (e) => {
    setAge(e.target.value);
    setDownloadDisable(false);
    modelButtonDownload.current.click();
  };
  // console.log("age--", age);

  const SelectExportResponse = (e) => setExportSelect(e.target.value);
  async function GetPhoneBookList() {
    try {
      setHideSkeleton(true);
      const result = await common_axios(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/bulk-group/get/phone-book/list`
        // `http://192.168.167.66:4900/user/phone-books/v1/list`
      );
      if (result.data.statusdescription.statusCode == 200) {
        setHideSkeleton(false);

        setData(result.data.listOfPlaysmsPhonebook);
      } else {
        setHideSkeleton(false);

        setOpen(false);
        // toast.error(result.data.statusdescription.statusDescription,{
        //   toastId: customId1,
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  async function GetBulkGroupList() {
    try {
      setHideSkeleton(true);
      const result = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/get-bulk-group`,
        {}
        // `http://192.168.167.66:4900/user/phone-books/v1/list`
      );
      if (result.data.statusdescription.statusCode == 200) {
        setHideSkeleton(false);

        setData(result.data.playsmsGroupPhonebooks);
      } else {
        setHideSkeleton(false);

        setOpen(false);
        // toast.error(result.data.statusdescription.statusDescription,{
        //   toastId: customId1,
        // });
      }
    } catch (error) {
      setOpen(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    if (MenuItemPhoneBook === 0) {
      GetPhoneBookList();
    } else {
      GetBulkGroupList();
    }
  }, [MenuItemPhoneBook]);
  // useEffect(()=>{
  //   if(MenuItemPhoneBook==undefined){
  //     setDisableMultiSelector(true)

  //   }
  //   else{
  //     setDisableMultiSelector(false)
  //   }
  // },[MenuItemPhoneBook])
  // const submitGid = async () => {
  //   try {
  //     // setOpen(true);
  //     // setHideSkeleton(true);
  //     if (MenuItemPhoneBook == 0) {
  //       if (age == "CSV") {
  //         const res = await common_axios.get(
  //           `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/phone-book/export/csv?phoneBookId=${gId}`
  //         );
  //         // console.log("first", res.data);
  //         setDownloadUrl(res.data);
  //       } else {
  //         const res = await common_axios.get(
  //           `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/export/phone-book/excel?phoneBookId=${gId}`
  //         );
  //         // console.log("first", res.data);
  //         setDownloadUrl(res.data);
  //       }
  //     } else {
  //       if (age == "CSV") {
  //         const res = await common_axios.get(
  //           `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/bulk-group/export/csv?bulkGroupId=${gId}`
  //         );
  //         // console.log("first", res.data);
  //         setDownloadUrl(res.data);
  //       } else {
  //         const res = await common_axios.get(
  //           `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/export/bulk-group/excel?bulkGroupId=${gId}`
  //         );
  //         // console.log("first", res.data);
  //         setDownloadUrl(res.data);
  //       }

  //       // http://192.168.167.66:4900/user/bulk-group/export/csv?bulkGroupId=6
  //     }
  //   } catch (error) {
  //     setHideSkeleton(false);
  //   }
  // };
  // useEffect(() => {
  //   submitGid();
  // }, [age]);

  useEffect(() => {
    parentCallback(MenuItemPhoneBook);
  }, [MenuItemPhoneBook]);


  useEffect(() => {
  setMenuItemPhoneBook()

    setGid([])
  }, [resetValue]);

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <body class="p-0">
          <section class="cmp">
            <div class="container-fluid">
              <div class="row">
                <section class="col-md-12 right_panel px-0">
                  <div class="container-fluid_1 px-0">
                    <section class="import_contacts" id="import_contacts">
                      <div class="card shadow-none border bg_blue">
                        <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                          Export Contact
                        </span>
                        {/* {
                          age !== "" && ( */}
                        <div>
                          <button
                            // ref={modelButtonApprove}
                            ref={modelButtonDownload}
                            type="button"
                            className="btn btn-primary d-none"
                            data-bs-toggle="modal"
                            data-bs-target="#staticBackdrop2"
                          >
                            Launch static backdrop modal
                          </button>

                          <div
                            className="modal fade"
                            id="staticBackdrop2"
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            tabindex="-1"
                            aria-labelledby="staticBackdrop2Label"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog ">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="staticBackdrop2Label"
                                  >
                                    Download
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>

                                <div className="modal-body">
                                  Are you sure you want to download the report ?
                                </div>

                                <div className="modal-footer justify-content-between">
                                  <button
                                    type="button"
                                    className="btn btn-secondary shadow"
                                    data-bs-dismiss="modal"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary editcolor shadow okbtn"
                                    data-bs-dismiss="modal"
                                    // onClick={() => {
                                    //   DownloadButtonApi
                                    // }}
                                    onClick={DownloadButtonApi}
                                  >
                                    Download
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* )
                        } */}
                        <ThemeProvider theme={theme}>
                        <form onSubmit={DownloadButtonApi}>
                          <div class="card-body">
                            <div className="row mt-3" id="select">
                              <div className="col-md-3 mt-aut ">
                                <div
                                  className="btn w-100 w_bt m-0 p-0"
                                  id="btn_nn8"
                                >
                                  <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Select List Type
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      className="text-start"
                                      id="demo-simple-select-autowidth"
                                      autowidth
                                      label="Select List Type"
                                      // required
                                      onChange={(event) => {
                                        setMenuItemPhoneBook(
                                          event.target.value
                                        );
                                      }}
                                    >
                                      <MenuItem value={0}>PhoneBook</MenuItem>
                                      <MenuItem value={1}>Bulk Group</MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>
                              </div>

                              {hideSkeleton == true ? (
                                <>
                                  <Box sx={{ width: "25%" }}>
                                    <Skeleton />
                                    <Skeleton animation="wave" />
                                    {/* <Skeleton animation={false} /> */}
                                  </Box>
                                </>
                              ) : (
                                <>
                                  {MenuItemPhoneBook == 0 ? (
                                    <>
                                      <div className="col-md-3">
                                        <ExportContactMultiSelect
                                          // DisableMultiSelector={DisableMultiSelector}
                                          data={data}
                                          parentCallback={callBackFunction1}
                                          MenuItemPhoneBook={MenuItemPhoneBook}
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="col-md-3">
                                        <BulkGroupMultiSelect
                                          data={data}
                                          parentCallback={callBackFunction2}
                                          MenuItemPhoneBook={MenuItemPhoneBook}
                                        />
                                      </div>
                                    </>
                                  )}
                                </>
                              )}

                              <div className="col-md-3">
                                <section
                                  class="modal_1 d-flex align-items-center"
                                  id="modal_8"
                                >
                                  {/* <!-- Modal --> */}
                                  {/* <FormControl
                                    disabled={gId.length <= 0}
                                    value={age}
                                    onChange={handleChangee}
                                    required
                                  >
                                    <FormLabel
                                      className="m-0"
                                      id="demo-row-radio-buttons-group-label"
                                    >
                                      File Format
                                    </FormLabel>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="row-radio-buttons-group"
                                      value={age}
                                    >
                                      <FormControlLabel
                                        value="CSV"
                                        control={<Radio />}
                                        label=".CSV"
                                        className="m-0"
                                      />
                                      <FormControlLabel
                                        value="excel"
                                        control={<Radio />}
                                        label="Excel"
                                        className="m-0"
                                      />
                                    </RadioGroup>
                                  </FormControl> */}
                                  <div className="">
                                    <button
                                      disabled={
                                        MenuItemPhoneBook === "" ||
                           gId == 0 || gId == null || MenuItemPhoneBook == null
                          }
                                      type="button"
                                      className="btn btn_wt_8 bg-gradient-primary m-0 ms-5 radius d-flex align-items-center"
                                      style={{ width: "auto" }}
                                      onClick={() => {
                                        modelButtonDownload.current.click();
                                      }}
                                      // disabled={DownloadDisable}
                                    >
                                      Download
                                    </button>
                                    {/* <button
                          // onClick={formik.resetForm}
                          onClick={uploadreset}
                          type="button"
                          className="btn bg-gradient-secondary m-0 ms-3 w_btn btn_w8 "
                        >
                          Reset
                          <SettingsBackupRestoreRoundedIcon
                            style={{ fontSize: "17px" }}
                          />{" "}
                        </button> */}
                                  </div>
                                </section>
                              </div>
                            </div>
                          </div>
                        </form>
                        </ThemeProvider>
                      </div>
                    </section>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </body>
      </main>
    </>
  );
};

export default ExportContact2;

